import { ClaimGenerationMethod } from "../enums";

export class ClaimGenerationMethodLookup {
    static get = () => [
        { label: 'Encounter Date', value: ClaimGenerationMethod.EncounterDate },
        { label: 'Statement Date', value: ClaimGenerationMethod.StatementDate }
    ];

}